import _ from 'lodash'

export const toPoint = (d) => ({
    angle: Number(d.angle),
    x: Number(d.fence_x),
    y: Number(d.fence_y),
    z: Number(d.fence_height),
    distance: Number(d.fence_distance),
})

export const toMinPoints = (data, field) => {
    const byAngle = _.groupBy(data, 'angle')
    const orderedByField = _.mapValues(byAngle, (d) => _.orderBy(d, field))
    const points = _.values(_.mapValues(orderedByField, (d) => d[0]))
    const ordered = _.orderBy(points, 'angle')

    // console.log('byAngle', byAngle);
    // console.log('orderedByField', orderedByField);
    // console.log('ordered', ordered);

    return ordered.map(toPoint)
}

export const toMaxPoints = (data, field) => {
    const byAngle = _.groupBy(data, 'angle')
    const orderedByAttribute = _.mapValues(byAngle, (d) => _.orderBy(d, field))
    const points = _.values(
        _.mapValues(orderedByAttribute, (d) => d[d.length - 1])
    )
    const ordered = _.orderBy(points, 'angle')

    return ordered.map(toPoint)
}
